// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RedirectRouteImport } from './routes/redirect'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as ShareableListsSlugRouteImport } from './routes/shareable-lists.$slug'
import { Route as LegalCustomerAgreementRouteImport } from './routes/legal/customer-agreement'
import { Route as CollectionSlugRouteImport } from './routes/collection.$slug'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminTypesenseRouteImport } from './routes/admin/typesense'
import { Route as AdminTemplateEditorRouteImport } from './routes/admin/template-editor'
import { Route as AdminRecsRouteImport } from './routes/admin/recs'
import { Route as AdminImpersonateRouteImport } from './routes/admin/impersonate'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppTagSettingsRouteImport } from './routes/_app/tag-settings'
import { Route as AppSlidePresentRouteImport } from './routes/_app/slide-present'
import { Route as AppSlideEditorRouteImport } from './routes/_app/slide-editor'
import { Route as AppResetPasswordRouteImport } from './routes/_app/reset-password'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppLogoutRouteImport } from './routes/_app/logout'
import { Route as AppListingsRouteImport } from './routes/_app/listings'
import { Route as AppChangePasswordRouteImport } from './routes/_app/change-password'
import { Route as PresentCoverTemplateRouteImport } from './routes/present.cover.$template'
import { Route as AppSpacesSpaceIdRouteImport } from './routes/_app/spaces.$spaceId'
import { Route as AppPresentationEditorPresentationIdRouteImport } from './routes/_app/presentation-editor.$presentationId'
import { Route as AppEventsEventSlugRouteImport } from './routes/_app/events.$eventSlug'
import { Route as EventEventIdMembershipIdLinksRouteImport } from './routes/event.$eventId.$membershipId.links'
import { Route as AppSpacesMainVenueSlugSpaceSlugRouteImport } from './routes/_app/spaces.$mainVenueSlug.$spaceSlug'
import { Route as AppEventsEventSlugGeneratePresentationTemplateIdRouteImport } from './routes/_app/events.$eventSlug_.generate-presentation.$templateId'
import { Route as AppEventsEventSlugPresentTemplateTemplateNameRouteImport } from './routes/_app/events.$eventSlug_.present.template.$templateName'

const RedirectRoute = RedirectRouteImport.update({
            id: '/redirect',path: '/redirect',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const ActivateRoute = ActivateRouteImport.update({
            id: '/activate',path: '/activate',getParentRoute: () => rootRouteImport
          })
const AdminRouteRoute = AdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AppRouteRoute = AppRouteRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const ShareableListsSlugRoute = ShareableListsSlugRouteImport.update({
            id: '/shareable-lists/$slug',path: '/shareable-lists/$slug',getParentRoute: () => rootRouteImport
          })
const LegalCustomerAgreementRoute = LegalCustomerAgreementRouteImport.update({
            id: '/legal/customer-agreement',path: '/legal/customer-agreement',getParentRoute: () => rootRouteImport
          })
const CollectionSlugRoute = CollectionSlugRouteImport.update({
            id: '/collection/$slug',path: '/collection/$slug',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRouteRoute
          })
const AdminTypesenseRoute = AdminTypesenseRouteImport.update({
            id: '/typesense',path: '/typesense',getParentRoute: () => AdminRouteRoute
          })
const AdminTemplateEditorRoute = AdminTemplateEditorRouteImport.update({
            id: '/template-editor',path: '/template-editor',getParentRoute: () => AdminRouteRoute
          })
const AdminRecsRoute = AdminRecsRouteImport.update({
            id: '/recs',path: '/recs',getParentRoute: () => AdminRouteRoute
          })
const AdminImpersonateRoute = AdminImpersonateRouteImport.update({
            id: '/impersonate',path: '/impersonate',getParentRoute: () => AdminRouteRoute
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRouteRoute
          })
const AppTagSettingsRoute = AppTagSettingsRouteImport.update({
            id: '/tag-settings',path: '/tag-settings',getParentRoute: () => AppRouteRoute
          })
const AppSlidePresentRoute = AppSlidePresentRouteImport.update({
            id: '/slide-present',path: '/slide-present',getParentRoute: () => AppRouteRoute
          })
const AppSlideEditorRoute = AppSlideEditorRouteImport.update({
            id: '/slide-editor',path: '/slide-editor',getParentRoute: () => AppRouteRoute
          })
const AppResetPasswordRoute = AppResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AppRouteRoute
          })
const AppProfileRoute = AppProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AppRouteRoute
          })
const AppLogoutRoute = AppLogoutRouteImport.update({
            id: '/logout',path: '/logout',getParentRoute: () => AppRouteRoute
          })
const AppListingsRoute = AppListingsRouteImport.update({
            id: '/listings',path: '/listings',getParentRoute: () => AppRouteRoute
          })
const AppChangePasswordRoute = AppChangePasswordRouteImport.update({
            id: '/change-password',path: '/change-password',getParentRoute: () => AppRouteRoute
          })
const PresentCoverTemplateRoute = PresentCoverTemplateRouteImport.update({
            id: '/present/cover/$template',path: '/present/cover/$template',getParentRoute: () => rootRouteImport
          })
const AppSpacesSpaceIdRoute = AppSpacesSpaceIdRouteImport.update({
            id: '/spaces/$spaceId',path: '/spaces/$spaceId',getParentRoute: () => AppRouteRoute
          })
const AppPresentationEditorPresentationIdRoute = AppPresentationEditorPresentationIdRouteImport.update({
            id: '/presentation-editor/$presentationId',path: '/presentation-editor/$presentationId',getParentRoute: () => AppRouteRoute
          })
const AppEventsEventSlugRoute = AppEventsEventSlugRouteImport.update({
            id: '/events/$eventSlug',path: '/events/$eventSlug',getParentRoute: () => AppRouteRoute
          })
const EventEventIdMembershipIdLinksRoute = EventEventIdMembershipIdLinksRouteImport.update({
            id: '/event/$eventId/$membershipId/links',path: '/event/$eventId/$membershipId/links',getParentRoute: () => rootRouteImport
          })
const AppSpacesMainVenueSlugSpaceSlugRoute = AppSpacesMainVenueSlugSpaceSlugRouteImport.update({
            id: '/spaces/$mainVenueSlug/$spaceSlug',path: '/spaces/$mainVenueSlug/$spaceSlug',getParentRoute: () => AppRouteRoute
          })
const AppEventsEventSlugGeneratePresentationTemplateIdRoute = AppEventsEventSlugGeneratePresentationTemplateIdRouteImport.update({
            id: '/events/$eventSlug_/generate-presentation/$templateId',path: '/events/$eventSlug/generate-presentation/$templateId',getParentRoute: () => AppRouteRoute
          })
const AppEventsEventSlugPresentTemplateTemplateNameRoute = AppEventsEventSlugPresentTemplateTemplateNameRouteImport.update({
            id: '/events/$eventSlug_/present/template/$templateName',path: '/events/$eventSlug/present/template/$templateName',getParentRoute: () => AppRouteRoute
          })





const AppRouteRouteChildren = {
  AppChangePasswordRoute: AppChangePasswordRoute,AppListingsRoute: AppListingsRoute,AppLogoutRoute: AppLogoutRoute,AppProfileRoute: AppProfileRoute,AppResetPasswordRoute: AppResetPasswordRoute,AppSlideEditorRoute: AppSlideEditorRoute,AppSlidePresentRoute: AppSlidePresentRoute,AppTagSettingsRoute: AppTagSettingsRoute,AppIndexRoute: AppIndexRoute,AppEventsEventSlugRoute: AppEventsEventSlugRoute,AppPresentationEditorPresentationIdRoute: AppPresentationEditorPresentationIdRoute,AppSpacesSpaceIdRoute: AppSpacesSpaceIdRoute,AppSpacesMainVenueSlugSpaceSlugRoute: AppSpacesMainVenueSlugSpaceSlugRoute,AppEventsEventSlugGeneratePresentationTemplateIdRoute: AppEventsEventSlugGeneratePresentationTemplateIdRoute,AppEventsEventSlugPresentTemplateTemplateNameRoute: AppEventsEventSlugPresentTemplateTemplateNameRoute
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(AppRouteRouteChildren)




const AdminRouteRouteChildren = {
  AdminImpersonateRoute: AdminImpersonateRoute,AdminRecsRoute: AdminRecsRoute,AdminTemplateEditorRoute: AdminTemplateEditorRoute,AdminTypesenseRoute: AdminTypesenseRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(AdminRouteRouteChildren)

const rootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,AdminRouteRoute: AdminRouteRouteWithChildren,ActivateRoute: ActivateRoute,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,OnboardingRoute: OnboardingRoute,RedirectRoute: RedirectRoute,CollectionSlugRoute: CollectionSlugRoute,LegalCustomerAgreementRoute: LegalCustomerAgreementRoute,ShareableListsSlugRoute: ShareableListsSlugRoute,PresentCoverTemplateRoute: PresentCoverTemplateRoute,EventEventIdMembershipIdLinksRoute: EventEventIdMembershipIdLinksRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)